export default __webpack_public_path__ + "static/media/bed.c4d54b10.svg";